var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-picker',{ref:"picker",attrs:{"show-toolbar":"","columns":_vm.columns},on:{"change":_vm.onChange,"confirm":_vm.onConfirm,"cancel":_vm.onCancel}})
}
var staticRenderFns = []

export { render, staticRenderFns }